import React from 'react';
import { MockedProvider } from '@apollo/react-testing';
import { ApolloProvider } from '@apollo/react-hooks';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import axe from '@axe-core/react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import settings from './settings.json';
import createClient from './clientSetup';
import { initiateConfig, isProd } from './config';
import { ALL_FUNDS_MOCK } from './components/FundListFragment/queries';
import { ALLOCATION_MOCK } from './flows/shared/services/allocation-service';
import { getMfRedirect } from './core/redirectUtils';

initiateConfig()
  .then(() => {
    // --redirect logic
    const redirectPath = getMfRedirect(window.location.pathname);
    if (redirectPath) {
      const query = window.location.search || '';
      const url = new URL(redirectPath + query, window.location.origin);
      window.location.replace(url.href);
      return;
    }

    // --End redirect logic--

    const client = createClient();
    const app = (
      <BrowserRouter basename="/personal-investing/tools/nasu/">
        <App />
      </BrowserRouter>
    );

    if (!isProd()) {
      axe(React, ReactDOM, 1000);
    }

    const appContainer = document.getElementById('root');
    const root = createRoot(appContainer);

    root.render(
      settings.mockedMode ? (
        <MockedProvider mocks={[...ALL_FUNDS_MOCK, ...ALLOCATION_MOCK]}>
          {app}
        </MockedProvider>
      ) : (
        <ApolloProvider client={client}>{app}</ApolloProvider>
      )
    );
  })
  .catch();
